import { Injectable } from 'angular-ts-decorators';

import { Observable, fromEvent } from 'rxjs';

/**
 * A service that creates observables from window events
 */
@Injectable('windowStreams')
export class WindowStreams {
  resize$: Observable<Event>;
  storage$: Observable<Event>;

  constructor(private $window: ng.IWindowService) {
    'ngInject';

    /**
     * Observable; emits the whole event object every time the `resize` event is triggered
     */
    this.resize$ = fromEvent($window, 'resize');

    /**
     * Observable; emits the whole event object every time the `storage` event is triggered
     */
    this.storage$ = fromEvent($window, 'storage');
  }
}
